import { render, staticRenderFns } from "./RobberyProtectionMeasuresQuestion.vue?vue&type=template&id=9a9eb0a8&scoped=true"
import script from "./RobberyProtectionMeasuresQuestion.vue?vue&type=script&lang=ts"
export * from "./RobberyProtectionMeasuresQuestion.vue?vue&type=script&lang=ts"
import style0 from "./RobberyProtectionMeasuresQuestion.vue?vue&type=style&index=0&id=9a9eb0a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a9eb0a8",
  null
  
)

export default component.exports